<ion-header [translucent]="true">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button [text]="'ZURUECK' | translate"></ion-back-button>
    </ion-buttons>
    <ion-title>{{ 'MONTAGEPLAN' | translate }}</ion-title>
    <ion-buttons slot="end">
      <ion-menu-button></ion-menu-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content>
  <div class="padding-16 margin-bottom-64">

    <!-- Tagesnavigation -->
    <div class="flex flex-row vertical-center space-between margin-bottom-16">
      <work-ui-button
        (buttonClick)="goToPreviousDay()"
        [iconOnly]="true"
        iconName="chevron_left"
        size="small"
        variant="secondary" />
      <work-ui-input-datepicker
        [singleDate]="selectedDate()"
        [disableHint]="true"
        (singleDateChange)="onDateChange($event)" />
      <work-ui-button
        (buttonClick)="goToNextDay()"
        [iconOnly]="true"
        iconName="chevron_right"
        size="small"
        variant="secondary" />
    </div>

    <!-- Tagesansicht -->
    <work-ui-montageplan-day-overview
      [date]="selectedDate()"
      [teamsActive]="teamsAll()"
      [allowChangeTeamOfMember]="true"
      [showMontageplanNotes]="true"
      (openProjectDetails)="openProjectDetails($event)"
      (openUserDetails)="openUserDetails($event)" />

  </div>
</ion-content>
